var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnergyDrink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#energy-drink_svg__clip0)",
    fill: "#91C300",
    stroke: "#91C300",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.719 3.985V1.563a.78.78 0 00-.782-.782H7.063a.78.78 0 00-.78.781v2.423a3.914 3.914 0 00-3.126 3.828v34.374c0 1.282.63 2.413 1.587 3.126h-.024v3.124c0 .433.349.782.781.782h25a.78.78 0 00.781-.782v-3.124h-.024a3.892 3.892 0 001.587-3.126V7.813a3.914 3.914 0 00-3.125-3.828zm-1.563-1.641v1.562H7.844V2.344h20.312zM7.063 5.469h21.875a2.347 2.347 0 012.343 2.343v.782H4.72v-.781a2.347 2.347 0 012.343-2.344zm24.218 4.687v29.688H4.72V10.156H31.28zm-1.562 37.5H6.28v-1.641a3.9 3.9 0 00.782.079h21.875a3.9 3.9 0 00.78-.08v1.642zm-.782-3.125H7.063a2.347 2.347 0 01-2.343-2.343v-.782H31.28v.782a2.347 2.347 0 01-2.343 2.343z",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.92 26.394h0a1.033 1.033 0 01-.156-.916h0l3.125-10.156h0l.24.073a.781.781 0 01.746-.551h7.813a.782.782 0 01.65 1.215L10.92 26.394zm0 0c.195.264.503.419.83.419h3.086l-3.243 7.135a1.03 1.03 0 001.667 1.156l11.72-11.719a1.031 1.031 0 00-.73-1.76h-4.323l-9.007 4.769zm5.518-1.644h-3.292l2.49-8.094h5.125l-3.619 5.428h0A1.032 1.032 0 0018 23.688h3.76l-5.937 5.937 1.553-3.416c.145-.32.118-.69-.071-.985h0a1.031 1.031 0 00-.867-.474z",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "energy-drink_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.25)",
    d: "M0 0h35v50H0z"
  })))));
}

export default SvgEnergyDrink;